import { c as _c } from "react/compiler-runtime";
import AlertComponent, { AlertType } from '@spa/components/alert/alert.component';
import { DeleteMyWishlistInAddProductPayload, createMyWishlistRequested } from '@spa/lib/store/wishlists/wishlistsSlice';
import { Formik, FormikProps } from 'formik';
import React, { Fragment, ReactElement, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { Schema } from 'yup';
import WishlistFormComponent from '@spa/components/forms/wishlist-form/wishlist-form.component';
import { WishlistFormFields } from '@spa/components/forms/wishlist-form/wishlistFormTypes';
import WishlistFormSchemaValidation from '@spa/components/forms/wishlist-form/wishlistFormSchema';
import { WishlistTrackingProduct } from '@spa/lib/tracking/productsToAnalyticsItemConverter';
import { WishlistsActionsOriginType } from '@spa/lib/tracking/trackWishlistsActions';
import classNames from 'clsx';
import generateActionId from '@spa/lib/generateActionId';
import selectFailedCreateMyWishlistActionIds from '@spa/lib/store/wishlists/selectors/selectFailedCreateMyWishlistActionIds';
import selectSucceededCreateMyWishlistActionIds from '@spa/lib/store/wishlists/selectors/selectSucceededCreateMyWishlistActionIds';
import styles from './add-wishlist.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly deleteWishlistPayload?: DeleteMyWishlistInAddProductPayload;
  readonly handleCancelAction: () => void;
  readonly origin?: WishlistsActionsOriginType;
  readonly product?: WishlistTrackingProduct;
}
function AddWishlistComponent(t0) {
  const $ = _c(46);
  const {
    deleteWishlistPayload,
    handleCancelAction,
    origin,
    product
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("add-wishlist");
  const {
    formatMessage: formsFormatMessage
  } = useNamespacedIntl("forms");
  const dispatch = useDispatch();
  const [lastActionId, setLastActionId] = useState(null);
  const succeededCreateWishlistActionIds = useSelector(selectSucceededCreateMyWishlistActionIds);
  const failedCreateWishlistActionIds = useSelector(selectFailedCreateMyWishlistActionIds);
  let t1;
  if ($[0] !== failedCreateWishlistActionIds || $[1] !== lastActionId || $[2] !== succeededCreateWishlistActionIds) {
    t1 = lastActionId !== null && !succeededCreateWishlistActionIds.includes(lastActionId) && !failedCreateWishlistActionIds.includes(lastActionId);
    $[0] = failedCreateWishlistActionIds;
    $[1] = lastActionId;
    $[2] = succeededCreateWishlistActionIds;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isAddingNewWishlist = t1;
  if (lastActionId !== null && succeededCreateWishlistActionIds.includes(lastActionId)) {
    handleCancelAction();
  }
  let t2;
  if ($[4] !== failedCreateWishlistActionIds || $[5] !== lastActionId) {
    t2 = lastActionId !== null && failedCreateWishlistActionIds.includes(lastActionId);
    $[4] = failedCreateWishlistActionIds;
    $[5] = lastActionId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const createWishlistFailed = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      name: "",
      description: ""
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const initialFormValues = t3;
  let t4;
  if ($[8] !== formsFormatMessage) {
    t4 = WishlistFormSchemaValidation(formsFormatMessage);
    $[8] = formsFormatMessage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const formSchema = t4;
  let t5;
  if ($[10] !== formatMessage) {
    t5 = formatMessage("iconAlt");
    $[10] = formatMessage;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <ImageComponent className={styles["add-wishlist__icon"]} src="/assets/icons/new_wishlist.svg" alt={t5} width={96} height={96} />;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classNames("bold", styles["add-wishlist__headline"]);
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== formatMessage) {
    t8 = formatMessage("title");
    $[15] = formatMessage;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <h3 className={t7}>{t8}</h3>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = classNames("text-lg", styles["add-wishlist__subtitle"]);
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== formatMessage) {
    t11 = formatMessage("subtitle");
    $[20] = formatMessage;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = <span className={t10}>{t11}</span>;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== createWishlistFailed || $[25] !== formatMessage) {
    t13 = createWishlistFailed && <AlertComponent alertType={AlertType.ERROR} content={formatMessage("error")} />;
    $[24] = createWishlistFailed;
    $[25] = formatMessage;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== deleteWishlistPayload || $[28] !== dispatch || $[29] !== origin || $[30] !== product) {
    t14 = async t15 => {
      const {
        name,
        description
      } = t15;
      const actionId = generateActionId();
      setLastActionId(actionId);
      dispatch(createMyWishlistRequested({
        actionId,
        input: {
          isDefault: false,
          name,
          description: description ?? null
        },
        isDefault: false,
        origin,
        products: product ? [product] : undefined,
        deletedWishlist: deleteWishlistPayload
      }));
    };
    $[27] = deleteWishlistPayload;
    $[28] = dispatch;
    $[29] = origin;
    $[30] = product;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== formatMessage || $[33] !== handleCancelAction || $[34] !== isAddingNewWishlist) {
    t15 = t16 => {
      const {
        errors,
        isSubmitting,
        submitForm,
        touched,
        values
      } = t16;
      return <Fragment><div className={styles["add-wishlist__form"]}><WishlistFormComponent errors={errors} touched={touched} values={values} isSubmitting={isAddingNewWishlist || isSubmitting} /></div><div className={styles["add-wishlist__buttons"]}><ButtonComponent buttonType={ButtonType.TERTIARY} disabled={isAddingNewWishlist || isSubmitting} text={formatMessage("buttons.cancel")} onClick={handleCancelAction} /><ButtonComponent buttonType={ButtonType.PRIMARY} disabled={isAddingNewWishlist || isSubmitting} showSpinner={isAddingNewWishlist || isSubmitting} text={formatMessage("buttons.createList")} onClick={submitForm} /></div></Fragment>;
    };
    $[32] = formatMessage;
    $[33] = handleCancelAction;
    $[34] = isAddingNewWishlist;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== formSchema || $[37] !== t14 || $[38] !== t15) {
    t16 = <Formik initialValues={initialFormValues} validationSchema={formSchema} validateOnChange={false} onSubmit={t14}>{t15}</Formik>;
    $[36] = formSchema;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t12 || $[41] !== t13 || $[42] !== t16 || $[43] !== t6 || $[44] !== t9) {
    t17 = <div className={styles["add-wishlist"]}>{t6}{t9}{t12}{t13}{t16}</div>;
    $[40] = t12;
    $[41] = t13;
    $[42] = t16;
    $[43] = t6;
    $[44] = t9;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
}
export default memo(AddWishlistComponent);